module.exports = __webpack_public_path__ + "static/media/rocks.caaa8a36.jpg";